import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { Pointage } from '../creneaux/pointage.model';
import { UUID } from '../uuid.model';
import { DeclarationPosition } from './declaration-position.model';
import { Declaration } from './declaration.model';
import { IVacation } from './vacation.interface';

export class VacationGardiennage implements IVacation {
  constructor(
    public id: UUID,
    public debut: dayjs.Dayjs,
    public arriveeSurSite: dayjs.Dayjs | undefined,
    public fin?: dayjs.Dayjs,
    public anomalies: Declaration[] = [],
    // public infos: Declaration[] = [],
    public positionsDeclarees: DeclarationPosition[] = [],
    public type = CreneauType.GARDIENNAGE,
    public pointages: Pointage[] = []
  ) {}

  public static hydrate(vacation: VacationGardiennage): VacationGardiennage {
    return new VacationGardiennage(
      vacation.id,
      dayjs(vacation.debut),
      vacation.arriveeSurSite ? dayjs(vacation.arriveeSurSite) : undefined,
      vacation.fin ? dayjs(vacation.fin) : undefined,
      vacation.anomalies ? vacation.anomalies.map(Declaration.hydrate) : [],
      // vacation.infos ? vacation.infos.map(Declaration.hydrate) : [],
      vacation.positionsDeclarees ? vacation.positionsDeclarees.map(DeclarationPosition.hydrate) : [],
      vacation.type,
      vacation.pointages ? vacation.pointages.map(Pointage.hydrate) : []
    );
  }
}
